import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import {SIGN_PERMISSION, MANAGE_PROJECT_PERMISSION, MANAGER_ROLE} from '../../../../../utils/constant';
import DatetimeFormat from '../../../../datetime/DatetimeFormat';
import authenticationService from '../../../../../services/authentication/AuthenticationService';

function RowView(props) {
  const isManager = authenticationService.roles().isManager();
  const {user} = props;
  const icon = props.loading ?
    <Icon icon="loader"/> :
    <span
      data-id="unlink-action"
      onClick={props.onUnlink}
      tooltip={I18n.t('user.actions.untieUser', {firstname: user.firstName, lastname: user.lastName})}
    >
      <Icon icon="unlink"/>
    </span>;
  const creationDate = <DatetimeFormat
    value={user.createdDate}
    format="shortDate"
  />;
  const userRole = user.roleByOrganisationIds[props.organisationId];

  const userPermissions = user.permissionsByOrganisationIds && user.permissionsByOrganisationIds[props.organisationId];
  const canSign = userPermissions && userPermissions.includes(SIGN_PERMISSION);
  const canManageProject = userPermissions && userPermissions.includes(MANAGE_PROJECT_PERMISSION);
  const canUntie = !canSign && (userRole !== MANAGER_ROLE) && isManager;
  const enabledStyle = user.enabled ? 'show-on-hover-container' : 'disabled show-on-hover-container';

  return (
    <tr className={`${enabledStyle}`}>
      <td>
        <div className="inline-container">
          {user.invited && <Icon
            data-id="mail-icon"
            icon="paper-plane"
          />}
          <span data-id="lastName">{user.lastName}</span>
        </div>
      </td>
      <td>
        <span className="inline-container">
          <span data-id="firstName">{user.firstName}</span>
          <span
            className="clickable show-on-hover-element"
          >{canUntie && icon}</span>
        </span>
      </td>
      <td><a
        target="_blank"
        rel="noopener noreferrer"
        href={`mailto:${user.email}`}
      ><span data-id="email">{user.email}</span></a></td>
      <td><span data-id="phoneNumber">{user.phoneNumber}</span></td>
      <td><span data-id="createdDate">{creationDate}</span></td>
      <td><span data-id="role">{I18n.t(`user.roles.${userRole}`)}</span></td>
      <td><span data-id="sign">{canSign ? <Icon icon="check"/> : null}</span></td>
      <td><span data-id="manage-project">{canManageProject ? <Icon icon="check"/> : null}</span></td>
      <td>
        {!user.enabled &&
          <div
            tooltip={I18n.t('user.deactivatedUser', {firstname: user.firstName, lastname: user.lastName})}
            flow="left"
          >
            <Icon icon="info"/>
          </div>
        }
      </td>
    </tr>
  );
}

RowView.propTypes = {
  loading: PropTypes.bool.isRequired,
  organisationId: PropTypes.number.isRequired,
  user: PropTypes.object.isRequired,
  onUnlink: PropTypes.func.isRequired
};

export default RowView;
